import { getToken, modifyReturnReasonList } from "../../../helper/common";
import agent from "../../services/agent";
// import { clearForm } from "./form.actions";
import {
  CLOSE_CREATE_RETURN_REASON_MODAL,
  CLOSE_UPDATE_RETURN_REASON_MODAL,
  CREATE_RETURN_REASON_ERROR,
  CREATE_RETURN_REASON_PENDING,
  CREATE_RETURN_REASON_SUCCESS,
  GET_RETURN_REASON_PENDING,
  OPEN_CREATE_RETURN_REASON_MODAL,
  OPEN_UPDATE_RETURN_REASON_MODAL,
  SET_RETURN_REASON_LIST,
  UPDATE_RETURN_REASON_ERROR,
  UPDATE_RETURN_REASON_PENDING,
  UPDATE_RETURN_REASON_SUCCESS,
  SET_RETURN_REASON_DETAILS,
  SET_ASSIGNABLE_RETURN_REASON_LIST_ASYNC,
  ADD_RETURN_REASON,
  RETURN_REASON_LIST_ERROR,
  CLEAR_UPDATE_RETURN_REASON_ERROR,
  CLEAR_CREATE_RETURN_REASON_ERROR,
  RETURN_REASON_LIST_ERROR_CLEAR,
} from "./actionTypes";
import { showSnackbarStatus } from "../../snackbar/actions";
import { clearForm } from "../../form/actions";
import trimmedValues from "../../../helper/trimmer";
import { setIsInlineUpdate } from "../SettingsInlineUpdate/actions";
// import { showSnackbarStatus } from "./snackbar.actions";

//--------------------------------RETURN-REASON-LIST------------------------------------------------
export const setReturnReasonList = (returnReasonsOdata) => ({
  type: SET_RETURN_REASON_LIST,
  payload: { returnReasonsOdata },
});

export const getReturnReasonPending = () => ({
  type: GET_RETURN_REASON_PENDING,
});

export const returnReasonListError = (errorMessage) => ({
  type: RETURN_REASON_LIST_ERROR,
  payload: { errorMessage },
});

export const returnReasonListErrorClear = () => ({
  type: RETURN_REASON_LIST_ERROR_CLEAR,
});

export const getReturnReasonList = (page, currentPage, searchReason, searchIsActive, searchCreatedBy, searchCreatedTimeStamp, sortDirection, sortOrder) => (dispatch) => {
  dispatch(getReturnReasonPending());
  getToken(dispatch).then((accessToken) => {
    agent.ReturnReason.getReturnReasonList(accessToken, page, currentPage, searchReason, searchIsActive, searchCreatedBy, searchCreatedTimeStamp, sortDirection, sortOrder)
      .then((returnReasonList) => {
        dispatch(setReturnReasonList(returnReasonList));
        dispatch(returnReasonListErrorClear());
      })
      .catch((err) => {
        console.log("getReturnReasonList server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(returnReasonListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(returnReasonListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//--------------------------------RETURN-REASON-CREATE----------------------------------------------
export const openCreateReturnReasonModal = () => ({
  type: OPEN_CREATE_RETURN_REASON_MODAL,
});

export const closeCreateReturnReasonModal = () => ({
  type: CLOSE_CREATE_RETURN_REASON_MODAL,
});

export const addReturnReason = (AddReturnReasonForm) => ({
  type: ADD_RETURN_REASON,
  payload: { AddReturnReasonForm },
});

export const createReturnReasonPending = () => ({
  type: CREATE_RETURN_REASON_PENDING,
});

export const createReturnReasonSuccess = () => ({
  type: CREATE_RETURN_REASON_SUCCESS,
});

export const createReturnReasonError = (errorMessage) => ({
  type: CREATE_RETURN_REASON_ERROR,
  payload: { errorMessage },
});

export const clearCreateReturnReasonError = () => ({
  type: CLEAR_CREATE_RETURN_REASON_ERROR,
});
const setAssignableReturnReasonListForAsyncSelect = (returnReasonsList, searchValue) => ({
  type: SET_ASSIGNABLE_RETURN_REASON_LIST_ASYNC,
  payload: { returnReasonsListAsync: returnReasonsList, searchValueAsync: searchValue },
});

export const createReturnReason = (AddReturnReason) => (dispatch) => {
  const values = trimmedValues(AddReturnReason);
  dispatch(createReturnReasonPending());
  getToken(dispatch).then((accessToken) => {
    agent.ReturnReason.create(accessToken, values)
      .then(() => {
        dispatch(clearCreateReturnReasonError());
        dispatch(createReturnReasonSuccess());
        dispatch(clearForm());
        dispatch(closeCreateReturnReasonModal());
        dispatch(getReturnReasonList());
        dispatch(showSnackbarStatus("Return reason created successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(createReturnReasonError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(createReturnReasonError(message));
        }
        console.log("createReturnReason server error", err);
        // dispatch(clearForm());
        // dispatch(createReturnReasonError(null));
        // dispatch(closeCreateReturnReasonModal());
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getAssignableReturnReasonForAsyncSelect = (searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.ReturnReason.getAssignableReturnReason(accessToken, searchValue)
      .then((returnReasonList) => {
        let returnReasonsListOptions = modifyReturnReasonList(returnReasonList);
        dispatch(setAssignableReturnReasonListForAsyncSelect(returnReasonsListOptions));
        callback && callback(returnReasonsListOptions);
      })
      .catch((err) => {
        console.log("getAssignableReturnReasonForAsyncSelect for dropdown server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        callback && callback();
      });
  });
};

//--------------------------------RETURN-REASON-EDIT------------------------------------------------
export const openUpdateReturnReasonModal = () => ({
  type: OPEN_UPDATE_RETURN_REASON_MODAL,
});

export const closeUpdateReturnReasonModal = () => ({
  type: CLOSE_UPDATE_RETURN_REASON_MODAL,
});

export const updateReturnReasonPending = () => ({
  type: UPDATE_RETURN_REASON_PENDING,
});

export const setReturnReasonDetails = (returnReasonDetails) => ({
  type: SET_RETURN_REASON_DETAILS,
  payload: { returnReasonDetails },
});

export const updateReturnReasonSuccess = () => ({
  type: UPDATE_RETURN_REASON_SUCCESS,
});

export const updateReturnReasonError = (errorMessage) => ({
  type: UPDATE_RETURN_REASON_ERROR,
  payload: { errorMessage },
});

export const clearUpdateReturnReasonError = () => ({
  type: CLEAR_UPDATE_RETURN_REASON_ERROR,
});

export const updateReturnReason = (data) => (dispatch) => {
  const values = trimmedValues(data);
  dispatch(updateReturnReasonPending());
  getToken(dispatch).then((accessToken) => {
    agent.ReturnReason.update(accessToken, values)
      .then(() => {
        dispatch(clearUpdateReturnReasonError());
        dispatch(updateReturnReasonSuccess());
        dispatch(clearForm());
        dispatch(closeUpdateReturnReasonModal());
        dispatch(setIsInlineUpdate());
        dispatch(getReturnReasonList());
        dispatch(showSnackbarStatus("Return reason updated successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateReturnReasonError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(updateReturnReasonError(message));
        }
        console.log("updateReturnReason server error", err);
        //   dispatch(clearForm());
        // dispatch(updateReturnReasonError(null));
        // dispatch(closeUpdateReturnReasonModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};